import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import './PageLayout.scss'
import './MediaStyle.scss'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import {Card, CardHeader, CardText} from 'material-ui/Card';
import FooterLayout from './FooterLayout';
import HeaderLayout from './HeaderLayout';
import LoginForm from '../../components/ModalWindow/LoginForm'
import RegisterForm from '../../components/ModalWindow/RegisterForm'
import ForgotPasswordForm from '../../components/ModalWindow/ForgotPasswordForm'
import MessageBar from '../../components/ModalWindow/MessageBar'
import Categories from '../../components/categories/Categories'
import Filters from '../../components/categories/Filters'
import { connect } from 'react-redux'
import LocationGroupModal from "../../routes/Home/components/LocationGroupModal/LocationGroupModal";

class PageLayout extends React.Component {

    static propTypes = {
        children: PropTypes.node
    };

    constructor(props) {
        super(props);

        this.state = {
            children: this.props.children,
            leftSidebarShow: this.props.leftSidebarShow
        };
    }

    componentWillReceiveProps (nextProps) {
        this.setState({
            children: nextProps.children,
            leftSidebarShow: nextProps.leftSidebarShow
        })
    }

    render () {

        return (
            <MuiThemeProvider muiTheme={getMuiTheme()}>
                <div className="global-wrp">
                    <MessageBar message={{text:''}} />
                    <LoginForm showWindow={false} />
                    <RegisterForm showWindow={false} />
                    <ForgotPasswordForm showWindow={false}  />

                    <HeaderLayout/>
                    <div className='container main-content'>
                        <div className="row">
                            <div className={this.state.leftSidebarShow ? 'col-lg-9 col-md-12' : 'col-lg-12 col-md-12'}>
                                <div className='page-layout__viewport'>
                                    {this.state.children}
                                </div>
                            </div>
                            <div className="col-lg-3 order-lg-first">
                                {
                                    this.state.leftSidebarShow && (
                                        <div className="col-lg-12 flex-shrink-1 mb-3 p-0">
                                            <img src="/images/charity.png" className="w-100" alt="Banner"/>
                                        </div>
                                    )
                                }
                                <div className={this.state.leftSidebarShow ? 'col-lg-12 sidebar-left p-0' : 'hidden-md-down col-lg-12 sidebar-left p-0'}>

                                    <Card className={'sidebar-content'} style={{display: this.state.leftSidebarShow ? 'block' : 'none'}}>
                                        <CardText>
                                            <Categories />
                                            <Filters />
                                        </CardText>
                                    </Card>
                                </div>
                            </div>

                        </div>
                    </div>

                    <LocationGroupModal />

                    <FooterLayout/>

                </div>
            </MuiThemeProvider>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {
        leftSidebarShow: props.location.pathname === '/' ? false : state.leftSidebarShow
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadCategories: () => dispatch(loadCategories())
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageLayout)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js